import React from 'react';
import { motion } from 'framer-motion';
export function ImageShowcase() {
  return <section className="relative w-full min-h-[60vh] flex items-center justify-center bg-background overflow-hidden py-20" data-id="element-160">
      {/* Background gradient effects */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-neon-purple/5 to-transparent" data-id="element-161"></div>

      {/* Floating glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-neon-cyan rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse" data-id="element-162"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-neon-pink rounded-full mix-blend-screen filter blur-3xl opacity-20 animate-pulse" style={{
      animationDelay: '0.5s'
    }} data-id="element-163"></div>

      {/* Centered image */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.8
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} viewport={{
      once: true
    }} className="relative z-10" data-id="element-164">
        <div className="relative" data-id="element-165">
          {/* Glow ring around image */}
          <div className="absolute -inset-4 bg-gradient-to-r from-neon-cyan via-neon-purple to-neon-pink rounded-2xl opacity-50 blur-xl animate-pulse" data-id="element-166"></div>

          {/* Image container */}
          <div className="relative rounded-2xl overflow-hidden border-2 border-white/20 shadow-[0_0_30px_rgba(139,92,246,0.3)]" data-id="element-167">
            <img src="https://cdn.magicpatterns.com/uploads/hgZdQFeirDBHh96STw82nJ/blue-small.gif" alt="Animated showcase" className="w-auto h-auto max-w-[300px] sm:max-w-[400px] md:max-w-[500px] object-contain" data-id="element-168" />
          </div>
        </div>
      </motion.div>
    </section>;
}